import {ColorName} from '../../enums/ColorName.js';

export const colorSwatch: RotbColor = {
    AcceptButton: '#7EB53B',
    CancelButton: '#BC4834',
    GenericButton1: '#DB7633',
    GenericButton2: '#D7B230',
    GenericButton3: '#51983B',
    GenericButton4: '#21A499',
    GenericButton5: '#528EDB',
    GetCoinsButton: '#F7BE09',
    SpendCoinsButton: '#5558B7',
    TitleText: '#87AADF',
    TitleBackground: '#4C6E9E',
    GenericButton: '#4D4993',
    DisabledButton: '#576464',
    SubTitle: '#FFFFFF',
    SubTitleBackground: '#3A4D70',
    DescriptionText: '#FFFFFF',
    SliderBackground: '#0E1322',
    SliderGround: '#2D4065',
    SubTitleHighBackground: '#446094',
    RankProgress: '#71AFF9',
    RankProgressBackground: '#30486E',
    RankBackground: '#405C8F',
    RankText: '#E18237',
    CoinText: '#DEF0F4',
    DisabledButtonText: '#0000008A',
    RequirementsBar: '#76AB2E',
    MissionRequirementsBG: '#62A5EA',
    MalwearCircle: '#FFC600',
    RequirementsBarBG: '#1E3C49',
    UpgradeDivotEmpty: '#4C4C4C',
    UpgradeDivotFull: '#FBCF06',
    CoinStoreButtonBG: '#4E3AD1',
    LockedButtonBG: '#4B5565',
    MainMenuMissions: '#3CAAE1',
    MainMenuShoppe: '#DD9930',
    MainMenuMore: '#7555A9',
    MoreLeaderboard: '#D9C024',
    MoreStats: '#ABBE11',
    MoreAchievements: '#0DB3A5',
    MoreMoreGames: '#4D8ECF',
    MoreOptions: '#765CC0',
    MusicButton: '#3FA0CA',
    ShoppePowerups: '#E6B423',
    ShoppePerks: '#A8B738',
    ShoppeMalwear: '#437BCC',
    ShoppeSpecialOffers: '#7659C3',
    PauseRestart: '#B776BC',
    PowerupPerksButton: '#A5BC23',
    MalwearSilhouette: '#000000',
    LeaderboardFacebookButton: '#598EB5',
    LeaderboardListBorder: '#0F212846',
    LeaderboardListBackground: '#0F212846',
    LeaderboardRefreshSpinner: '#5184C8',
    LeaderboardStatsMe: '#76C6E3',
    LeaderboardStatsThem: '#ACB2BC',
    LeaderboardOffline: '#2A5393',
    PowerUpRefill: '#FF0000', // Not defined in ColorSwatch in Unity. Bright red for now.
    PowerupPerksButtonRefill1: '#E26A0C',
    PowerupPerksButtonRefill2: '#AB2E13',
    PowerupPerksButtonLocked: '#7689A9',
    SaleBanner: '#007DD7',
    SaleOriginalPrice: '#00365D',
    InventoryAdditionText: '#FFFFFF',
    Window: '#5881B9',
    WindowGradient: '#82B7FF69',
    PerkLockedTint: '#6C77B1',

    // Colors below were missing from the original ColorSwatch in Unity
    Options: '#4B528D',
    HudBarBackground: '#1A3C48',
    HudLevelBackground: '#2B5965',
    HudLevelBar: '#93C05D',
    HudLevelLabel: '#6FC1CA',
    WindowGameover: '#314580',
    MalPortraitBackground: '#16263D',
    ScoreBackground: '#1D3253',
    ScoreBorder: '#1F3C6B',
    ShareButton: '#FF7E7E',
    ScoreCoinText: '#DE882B',
    ScoreInfoIcon: '#ADAEFF',
    PowerupLocked: '#425363',
    UiDarkText: '#4A4A4A',
    LeaderboardPlayerPanel: '#666f7f',
    LeaderboardSubText: '#b3c8e4',
    SkipButton: '#556E7D',
    NotificationBG: '#747E91',
    StartCounterText: '#7B4D34',
    StatsBackground: '#253556',
    PowerupPerksButtonDark: '#2A5080',
};

type RotbColor = {
    [key in keyof typeof ColorName]: string;
};
